import { Link } from "react-router-dom";
import Seo from "@/components/base/Seo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/base/BackToTop";

const site = "https://immaple.cn";

const principles = [
  { icon: "ri-focus-2-line", title: "先辨真假，再说故事", text: "能证实的才称报道，不能证实的就如实标注为小道消息或推测，绝不把传闻包装成结论。" },
  { icon: "ri-chat-check-line", title: "交叉验证，不采单方", text: "多来源比对、还原时间线，优先采用可验证的公开信息，减少二手转述造成的失真。" },
  { icon: "ri-eye-off-line", title: "不猎奇，不造谣", text: "关注行业机制与作品逻辑，不针对个体猎奇；涉及具体人物一律以官方信息为准。" },
  { icon: "ri-chat-3-line", title: "给结论留余地", text: "摆出多种可能，把判断空间留给读者。深挖不是下结论，而是提供看问题的新角度。" },
];

const journey = [
  { step: "01", title: "镜头之外，才见门道", text: "成立之初我们便确认：热闹之外的信息量，藏在道具、站位、时间码这些「边角料」里。" },
  { step: "02", title: "把吃瓜做成方法论", text: "逐步沉淀出「先看细节、再作验证、最后结论」的编辑方法，让四个栏目各司其职。" },
  { step: "03", title: "与你一起吃透每一个瓜", text: "持续更新明星动态与深度盘点，欢迎你带着线索来，我们一起把真相的轮廓拼得更完整。" },
];

const voices = [
  { quote: "不像纯八卦号那样标题党，它真的会把时间线拉出来一条条核对，读完有种「哦，原来是这么回事」的踏实感。", role: "追更三年的老读者" },
  { quote: "作为行业从业者，看到他们把幕后工种和细节讲得这么扎实，能感受到编辑是下过功夫的。", role: "一位匿名的影视从业者" },
  { quote: "最喜欢边角料栏目，聚光灯外的群演、服装、道具都被认真对待，这比单纯炒热度有意义得多。", role: "普通吃瓜群众" },
];

const jsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "AboutPage",
      name: "关于在线吃瓜编辑部",
      url: `${site}/about`,
      description: "了解在线吃瓜的定位、发展理念、内容原则与联系方式。",
    },
    {
      "@type": "Organization",
      name: "在线吃瓜",
      url: site,
      description: "深度娱乐观察内容站，聚焦明星动态、小道消息、未删细节与隐藏线索。",
      email: "tougao@chigua.readdy.site",
    },
  ],
};

export default function AboutPage() {
  return (
    <>
      <Seo
        title="关于我们 - 在线吃瓜编辑部｜品牌介绍与投稿说明"
        description="认识在线吃瓜编辑部：我们如何把吃瓜做成一件下功夫的事，内容原则与投稿方式一图看懂。理性吃瓜，从了解我们开始。"
        keywords="在线吃瓜,在线吃瓜关于我们,在线吃瓜编辑部,吃瓜投稿,深度娱乐观察"
        canonicalPath="/about"
        jsonLd={jsonLd}
      />
      <div className="flex min-h-screen flex-col">
        <Navbar />
        <main className="flex-1">
          <section className="bg-background-800 text-background-100">
            <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
              <nav className="text-xs text-background-100/60" aria-label="面包屑">
                <ol className="flex items-center gap-1.5">
                  <li><Link to="/" className="hover:text-accent-200">首页</Link></li>
                  <li><i className="ri-arrow-right-s-line"></i></li>
                  <li className="text-background-50 font-medium">关于我们</li>
                </ol>
              </nav>
              <div className="mt-8 max-w-3xl">
                <span className="inline-flex items-center gap-1.5 text-xs tracking-[0.2em] text-accent-300"><i className="ri-user-heart-line"></i>ABOUT 编辑部</span>
                <h1 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
                  把「吃瓜」，当成一件需要下功夫的事
                </h1>
                <p className="mt-5 text-base leading-8 text-background-100/80">
                  在线吃瓜是一个面向泛娱乐人群的深度观察内容站。我们不看热闹，更看门道：明星动态不是流水账，小道消息不该被当成定论，
                  未删细节与隐藏线索里，藏着行业真实的运转逻辑。欢迎来到编辑部，看看我们怎么把每一个瓜吃得更透更深。
                </p>
              </div>
            </div>
          </section>

          <section className="bg-background-50 border-b border-background-200">
            <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">我们是谁，网站为什么叫「在线吃瓜」</h2>
                <p className="mt-4 text-[15px] leading-8 text-foreground-600">
                  「吃瓜」本义是围观，但我们的愿望，是让你围观得「有营养」。当网络上铺满标题与情绪时，真正稀缺的是冷静的整理与耐心的比对——
                  这正是「在线吃瓜」想补上的一块拼图。我们把镜头调近到片场的角落、把时间线拉长到通告单之外，让每一次围观，都能带走一点新的理解。
                </p>
                <p className="mt-3 text-[15px] leading-8 text-foreground-600">
                  四个栏目——明星动态、小道消息、深度挖掘、边角料——恰好覆盖从「最新鲜」到「最纵深」的完整吃瓜路径，任你挑一路慢慢逛。
                </p>
                <div className="mt-6 flex flex-wrap gap-3">
                  <Link to="/" className="inline-flex items-center gap-2 whitespace-nowrap px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors">
                    <i className="ri-home-5-line"></i>回到首页
                  </Link>
                  <Link to="/channel/shendu" className="inline-flex items-center gap-2 whitespace-nowrap px-5 py-2.5 rounded-lg border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-400 hover:text-primary-700 transition-colors">
                    看一篇深度挖掘
                  </Link>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                {principles.slice(0, 2).map((p) => (
                  <div key={p.title} className="rounded-xl border border-background-200 bg-background-100 p-5">
                    <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary-100 text-primary-700"><i className={`${p.icon} text-lg`}></i></span>
                    <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{p.title}</h3>
                    <p className="mt-1.5 text-sm leading-6 text-foreground-600">{p.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="bg-background-100 border-b border-background-200">
            <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">内容原则：我们坚持这四件事</h2>
              <p className="mt-2 text-sm text-foreground-500">原则不是口号，而是每天写稿时对照的尺子。</p>
              <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {principles.map((p) => (
                  <div key={p.title} className="rounded-xl border border-background-200 bg-background-50 p-6 hover:border-primary-300 transition-colors">
                    <span className="flex items-center justify-center w-12 h-12 rounded-xl bg-accent-100 text-accent-800"><i className={`${p.icon} text-xl`}></i></span>
                    <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{p.title}</h3>
                    <p className="mt-2 text-sm leading-7 text-foreground-600">{p.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="bg-background-50 border-b border-background-200">
            <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16 grid grid-cols-1 lg:grid-cols-12 gap-8">
              <div className="lg:col-span-4">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">一路走来的三条信念</h2>
                <p className="mt-3 text-sm leading-7 text-foreground-500">编辑部不追求热点式生存，更看重长期主义的观察与积累。</p>
              </div>
              <div className="lg:col-span-8 space-y-4">
                {journey.map((j) => (
                  <div key={j.step} className="flex gap-5 rounded-xl border border-background-200 bg-background-100 p-5 md:p-6">
                    <span className="font-heading text-3xl font-bold text-primary-200 shrink-0">{j.step}</span>
                    <div>
                      <h3 className="font-heading text-base font-bold text-foreground-950">{j.title}</h3>
                      <p className="mt-1.5 text-sm leading-7 text-foreground-600">{j.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="bg-accent-100/50 border-b border-accent-200">
            <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">读者怎么说</h2>
              <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5">
                {voices.map((v) => (
                  <figure key={v.role} className="rounded-xl border border-accent-200 bg-background-50 p-6 flex flex-col">
                    <i className="ri-double-quotes-l text-2xl text-accent-400"></i>
                    <blockquote className="mt-2 text-sm leading-7 text-foreground-700 flex-1">{v.quote}</blockquote>
                    <figcaption className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
                      <span className="flex items-center justify-center w-7 h-7 rounded-full bg-accent-100 text-accent-800"><i className="ri-user-smile-line"></i></span>
                      {v.role}
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </section>

          <section className="bg-background-50">
            <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16 grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div className="rounded-2xl border border-background-200 bg-background-100 p-7 md:p-8">
                <span className="inline-flex items-center gap-1.5 text-xs tracking-widest text-primary-600"><i className="ri-send-plane-line"></i>JOIN 投稿</span>
                <h2 className="mt-3 font-heading text-xl md:text-2xl font-bold text-foreground-950">手上有线索？欢迎投给编辑部</h2>
                <p className="mt-3 text-sm leading-7 text-foreground-600">
                  投稿请尽量附上可验证的时间、来源截图与事件脉络。一经采用，我们会标注提供方式，并对来源做充分脱敏，保护你的安全。
                </p>
                <a href="mailto:tougao@chigua.readdy.site" className="mt-5 inline-flex items-center gap-2 whitespace-nowrap px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors">
                  <i className="ri-mail-line"></i>tougao@chigua.readdy.site
                </a>
              </div>
              <div className="rounded-2xl border border-background-200 bg-background-100 p-7 md:p-8">
                <span className="inline-flex items-center gap-1.5 text-xs tracking-widest text-accent-700"><i className="ri-message-3-line"></i>CONTACT 联系</span>
                <h2 className="mt-3 font-heading text-xl md:text-2xl font-bold text-foreground-950">其他合作与建议</h2>
                <p className="mt-3 text-sm leading-7 text-foreground-600">
                  无论是指正错误、交换观点，还是探讨深度观察的合作方式，都欢迎来信。我们会认真对待每一位读者的声音。
                </p>
                <div className="mt-5 flex flex-wrap gap-2.5">
                  <a href="mailto:hello@chigua.readdy.site" className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-accent-800 underline decoration-accent-300 underline-offset-4">hello@chigua.readdy.site</a>
                  <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500"><i className="ri-time-line"></i>工作日 9:00–18:00 回复</span>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
        <BackToTop />
      </div>
    </>
  );
}